module.exports = __webpack_public_path__ + "static/img/renovar-certificado.989ef59.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/renovar-certificado.png
// module id = 486
// module chunks = 0